import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";

import styles from "./styles";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function SubjectLinesAnnouncement({ open, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: styles.paper }}>
      <DialogContent sx={{ textAlign: "center", pt: 4 }}>
        <Box sx={styles.icon}>
          <Box component="i" className="fa-solid fa-shuffle" />
        </Box>
        <Typography sx={styles.title}>New: Multiple Subject Lines</Typography>
        <Typography sx={styles.body}>
          Add multiple subject lines to any outreach template and we'll rotate
          between them automatically. We'll show you which one gets the most
          replies, right on the template card.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button variant="contained" onClick={onClose} sx={styles.button}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
}
